import {psdApi} from './psdApi';
import {reactApi} from './reactApi';
import {responsiveApi} from './responsiveApi';
import {nextApi} from './nextApi';

const allApi = [...psdApi, ...reactApi, ...responsiveApi, ...nextApi];


const shuffle = a => {
    for (let i = a.length; i; i--) {
        let j = Math.floor(Math.random() * i);
        [a[i - 1], a[j]] = [a[j], a[i - 1]];
    }
}

shuffle(allApi);

export default allApi;